import blue from './sprites/blue.svg'
import cyan from './sprites/cyan.svg'
import green from './sprites/green.svg'
import lime from './sprites/lime.svg'
import orange from './sprites/orange.svg'
import pink from './sprites/pink.svg'
import red from './sprites/red.svg'
import white from './sprites/white.svg'

export const sprites = [
  blue, cyan, green, lime, orange, pink, red, white
]

